<template>
    <div v-show="image" class="bg-white">

        <div :id="mapContainer" style="height:400px;" class="w-full; z-10"></div>

      <div class="flex justify-center">
        <!-- Available Items Legend -->

          <div class="flex mx-4 items-center">
            <div class="w-4 h-4 rounded-full mr-2 bg-green-500"></div>
            verfügbar
          </div>

          <div class="flex mx-4 items-center">
            <div class="w-4 h-4 rounded-full mr-2 bg-red-500"></div>
            nicht verfügbar
          </div>

      </div>

      <portal to="modal" v-if="showModal">
        <modal @close="showModal = false">
          <!-- Dynamic header based on item type -->
          <template #header>
            {{ selectedItemType === 'desk' ? 'Schreibtisch' : 'Konferenzraum' }}-Aktionen
          </template>

          <!-- Dynamic content -->
          <template #default>
            <p>Was möchten Sie mit dem {{ itemTypeLabel }} <b>{{itemName}}</b> machen?</p>
          </template>

          <!-- Updated action buttons -->
          <template #action>
            <button-primary @click="bookItem">
              <template slot="icon"><i class="fa fa-plus"></i></template>
              {{ itemTypeLabel }} buchen
            </button-primary>
            <button-primary @click="editItem">
              <template slot="icon"><i class="fa fa-pencil"></i></template>
              {{ itemTypeLabel }} bearbeiten
            </button-primary>
          </template>
        </modal>
      </portal>



    </div>
</template>

<script>
import L from "leaflet";
import Card from "./UI/Card";
import ButtonPrimary from "./UI/ButtonPrimary";
import ButtonSecondary from "./UI/ButtonSecondary.vue";
import Modal from "./Modal";
import _ from "lodash"

export default {
    name: "NavigationFloor",

    components: {Modal, ButtonPrimary,ButtonSecondary, Card},

    props: {
        items: {
            type: Array,
            default: () => ([]),
        },
        unavailable: {
            type: Array,
            default: () => ([]),
        },
        value: {
            type: Array,
            default: () => ([]),
        },
        hybrid: {
            type: Boolean,
            default: () => false,
        }
    },

    watch: {
        items() {
            this.init();
        },
        value() {
            this.init();
        },
    },

    data: () => ({
        mapContainer: (Math.random() + 1).toString(36).substring(7),
        selectedId: null,
        map: null,
        showModal: false,
        defaultContent: [],
        markers: [],
        selectedItemType: null,
    }),

    computed: {
        whichDashboard() {
          const path = window.location.pathname;
          const parts = path.split('/').filter(p => p.length > 0);

          if (parts[0] === 'admin') {
            return 'old';
          } else if (parts[0] === 'admin-panel') {
            return 'new';
          }

          return parts.length > 0 ? parts[0] : null;
        },
        selected() {
            if (!this.selectedId) {
                return null;
            }
            return this.items.find(item => item.id === this.selectedId);
        },
      image() {
        const findMapLink = (arr) => {
          if (!arr || arr.length === 0) {
            return null;
          }
          const itemWithMap = arr.find(item => item.floor && item.floor.map_link);
          return itemWithMap ? itemWithMap.floor.map_link : null;
        };

        let mapLink = findMapLink(this.items);
        if (mapLink) {
          return mapLink;
        }

        mapLink = findMapLink(this.unavailable);
        if (mapLink) {
          return mapLink;
        }

        return 0;
      },
        positions() {
            return this.items.filter(el => el.position);
        },
        itemTypeLabel() {
          return {
            desk: 'Schreibtisch',
            conference_room: 'Konferenzraum',
            bookable: 'Buchbare Ressource'
          }[this.selectedItemType] || 'Element';
        },
        itemName(){
          return this.items.find(e=>e.id === this.selectedId)?.name;
        }
    },

    mounted() {
        this.init();
    },

    methods: {
        init() {
            if (this.map != null) {
                this.map.remove();
                this.map = null;
            }

            let img = new Image();

            img.onload = () => {
                let minZoom = - Math.ceil( Math.max(img.width + img.height) / 1000 );
                this.map = L.map(this.mapContainer, {
                    crs: L.CRS.Simple,
                    minZoom: minZoom,
                    maxZoom: 2,
                    zoomSnap: 0.25,
                    zoomControl: false,
                });

                this.createMap(img.width, img.height)
            }
            img.src = this.image;
        },

        overlap(rect1, rect2) {
            return(!(rect1.right < rect2.left ||
                rect1.left > rect2.right ||
                rect1.bottom < rect2.top ||
                rect1.top > rect2.bottom));
        },
        hideOverlappingTooltips() {
            let i;
            let rects = [];
            let tooltips = document.getElementsByClassName('myTooltip');
            for (i = 0; i < tooltips.length; i++) {
                rects[i] = tooltips[i].getBoundingClientRect();
            }
            for (i = 0; i < tooltips.length; i++) {
                if (tooltips[i].style.visibility !== 'hidden') {
                    for (let j = 0; j < tooltips.length; j++) {
                        if(tooltips[j].style.visibility === "hidden" || i===j){
                            continue;
                        }
                        if (this.overlap(rects[i], rects[j])) {
                            let ti = this.markers.find(m=>`leaflet-tooltip-${m._tooltip._leaflet_id}`===tooltips[i].id);
                            let tj = this.markers.find(m=>`leaflet-tooltip-${m._tooltip._leaflet_id}`===tooltips[j].id);
                            tooltips[i].style.transform = `translate3d(${(ti._tooltip._contentNode._leaflet_pos.x + tj._tooltip._contentNode._leaflet_pos.x)/2}px, ${(ti._tooltip._contentNode._leaflet_pos.y + tj._tooltip._contentNode._leaflet_pos.y)/2}px, 0px)`
                            tooltips[i].innerHTML = [tooltips[i].innerHTML,tooltips[j].innerHTML].join(" ");
                            tooltips[j].style.visibility = 'hidden';
                            rects[i] = tooltips[i].getBoundingClientRect();
                        }
                    }
                }
            }
        },

        createMap(width, height) {
            this.markers = [];
            let bounds = [[0, 0], [height, width]];
            L.imageOverlay(this.image, bounds).addTo(this.map);
            this.map.setMaxBounds(bounds);
            this.map.fitBounds(bounds);
            this.add();
        },

        add() {
            this.addAvailable();
            this.addUnavailable();

            this.defaultContent = [].slice.call(document.getElementsByClassName('myTooltip')).map(e=>e.innerHTML);
            this.hideOverlappingTooltips();
            this.map.on('zoomstart', (evt)=> {
                let tooltips = document.getElementsByClassName('myTooltip');
                for (let i = 0; i < tooltips.length; i++) {
                    tooltips[i].style.visibility = '';
                    tooltips[i].innerHTML = this.defaultContent[i];
                }
            });
            this.map.on('zoomend', _.debounce((evt)=> {
                this.hideOverlappingTooltips();
            }),300);
        },
        setZoom() {
            this.setZoomItems(this.positions);
        },
        setZoomItems(items) {
            if (items.length === 0) {
                return;
            }

            let [l, t] = items[0].position.center;
            let [r, b] = items[0].position.center;

            items.forEach(desk => {
                l = Math.min(l, desk.position.center[0]);
                b = Math.min(b, desk.position.center[1]);
                r = Math.max(r, desk.position.center[0]);
                t = Math.max(t, desk.position.center[1]);
            });

            // look around zoom
            let w = 0;
            items.forEach(desk => {
                w = Math.max(w, desk.position.height, desk.position.width, desk.position.radius);
            });
            w *= 5;

            this.map.fitBounds([
                [l - w, t + w],
                [r + w, b - w]
            ]);
        },
      addAvailable() {
        this.items.forEach(item => {
          if (!item.position) return;

          let color = "green"

          const isSelected = this.isSelected(item.id);
          if(isSelected) color = 'blue'; // Keep selection color

          let marker = this.getMarker(item);
          let text = this.getToolTip(item, true);
          this.drawRectangle(item.id, true, item.position, color, text, marker,false,item.item_type);
        });
      },

      addUnavailable() {
        this.unavailable.forEach(item => {
          if (!item.position) return;
          let color = "red"; // Default red

          let marker = this.getMarker(item);
          let text = this.getToolTip(item, false);
          let isCheckedIn = item.bookings && item.bookings[0]?.checked_in_at !== undefined;

          this.drawRectangle(item.id, false, item.position, color, text, marker, isCheckedIn, item.item_type);
        });
      },

        drawRectangle(identifier, clickable, position, color, description, marker, isCheckedIn = false, itemType= "floor"){
            let layer;

            if (position.type === 'circle') {
                layer = L.circle(position.center, {
                    color: color,
                    radius: position.radius,
                    weight: 1,
                    id: identifier,
                    itemType: itemType
                });
            } else {
                layer = L.polygon([
                    [position.center[0] + position.height, position.center[1] - position.width],
                    [position.center[0] + position.height, position.center[1] + position.width],
                    [position.center[0] - position.height, position.center[1] + position.width],
                    [position.center[0] - position.height, position.center[1] - position.width],
                ], {
                    color: color,
                    weight: 1,
                    id: identifier,
                    itemType: itemType
                });

                this.rotateRectangle(position, layer)
            }

            layer
                .bindTooltip(description)
                .addTo(this.map);

            if(clickable){
                layer.on('click', (e) => {
                  const type = e.target.options.itemType;
                  this.selectedId = e.target.options.id;
                  this.selectedItemType = type;
                  this.selectItem(e.target.options.id);
                  if(this.hybrid && this.whichDashboard === "new") {
                    this.showModal = true
                  }else{
                    this.bookItem()
                  }
                });
            }

            if(marker){
                let [l, t] = position.center;
                let markerOnMap = L.marker([l, t], {
                    opacity: 0,
                    icon: L.divIcon({
                        iconAnchor: [0, 0],
                        iconSize: [0, 0],
                    }),
                });

                markerOnMap.bindTooltip(marker, {
                    permanent: true,
                    className: 'myTooltip' +
                        (isCheckedIn
                            ? ' checkedIn'
                            : ''),
                    offset: [0, 0],
                    direction: 'center',
                    interactive: true
                });
                this.markers.push(markerOnMap);
                markerOnMap.addTo(this.map);
            }
        },

        isSelected(id) {
            return this.value.includes(id);
        },

        getToolTip(item, available = true){
            if(available){
                return item.name + '<br>' + (item.details || '');
            }

            let bookings = item.bookings || item.schedules || [];
            let text = bookings?  bookings.map(booking => {

                const start = (new Date(booking.start));
                const result = start.toLocaleString('de-DE', {
                    hour: '2-digit',
                    minute: '2-digit'
                });

                const resultEnd = (new Date(booking.end)).toLocaleString('de-DE', {
                    hour: '2-digit',
                    minute: '2-digit'
                });

                let checkIn = booking.checked_in_at
                    ? new Date(booking.checked_in_at).toLocaleString(
                        'de-DE',
                        {
                            hour: '2-digit',
                            minute: '2-digit',
                        }
                    )
                    : null;

                checkIn = checkIn
                    ? ' ,eingecheckt um ' + checkIn
                    : '';

                if (resultEnd === '00:00') {
                    return 'gebucht ab ' +
                        result +
                        ' Uhr ' +
                        checkIn +
                        ' - ' +
                        booking.user_or_reservation_text;
                }

                // 01.02. 00:00 - 24:00 Uhr
                return 'gebucht von ' +
                    result +
                    ' - ' +
                    resultEnd +
                    ' Uhr ' +
                    checkIn +
                    ' - ' +
                    booking.user_or_reservation_text;
            }).join("<br>"): "";

            if (text.length === 0) {
                text = item.owner? `Fester Arbeitsplatz von ${item.owner.first_name} ${item.owner.name} <br> ${item.desk_releases && item.desk_releases.length? item.desk_releases.map(r=>("freigegeben: "+ r.begin + "-"+ r.end)+"Uhr").join(", "): ""}`: 'Nicht verfügbar';
            }

            return item.name + "<br>" + text + '<br>' + (item.details || '');
        },

        getMarker(item){
            let marker;
            if(item.owner){
                let s = (item.owner.first_name?.substring(0, 1) + item.owner.name?.substring(0, 1));
                marker = s? s.toUpperCase(): "";
                if(item.owner.avatar){
                    marker = `<div class="avatar-div"><img class="rounded-full w-full h-full" src='${item.owner.avatar}' alt='${marker}' /></div>`
                }
            }

            if(item.type === 'disabled'){
                marker = '<i class="fa fa-lock"></i>';
            }

            let bookings = item.bookings || item.schedules || [];

            if(bookings && bookings.length) {
                let s = (bookings[0]?.user?.first_name.substring(0, 1) + bookings[0]?.user?.name.substring(0, 1));
                marker = s? s.toUpperCase(): "";
                if (bookings[0].user && bookings[0].user.avatar) {
                    marker = `<div class="avatar-div"><img class="w-8 max-h-8 rounded-full" src='${bookings[0]?.user?.avatar}' alt='${marker}' /></div>`;
                }
            }

            return marker;
        },

        selectItem(id) {
            this.selectedId = id;
            if(!this.hybrid) {
              this.confirm();
            }

          this.showModal = this.whichDashboard === "new";
        },

        confirm() {
            this.$emit('selected', this.selected);
        },

        // Function to rotate a point around a center
        rotateRectangle(position, rectangle){
            if(!position){
                return;
            }
            let center = rectangle.getBounds().getCenter();
            let rotationRadians = (position.angle * Math.PI) / 180;
            let rotatedCorners = rectangle.getLatLngs()[0].map((corner) => {
                return this.rotatePoint(corner, center, rotationRadians);
            });

            rectangle.setLatLngs([rotatedCorners]);
        },
        rotatePoint(point, center, angle) {
            let x = center.lng + (point.lng - center.lng) * Math.cos(angle) - (point.lat - center.lat) * Math.sin(angle);
            let y = center.lat + (point.lng - center.lng) * Math.sin(angle) + (point.lat - center.lat) * Math.cos(angle);
            return L.latLng(y, x);
        },

      bookItem() {
          let activeTab = null;
          if(this.selectedItemType === 'bookable'){
            activeTab = this.items.find((e) => e.id === this.selectedId)?.bookable_category_id;
          }
          if(this.whichDashboard === "new") {
            const routes = {
              desk: `/admin-panel/booking/schedules/create?desk=${this.selectedId}`,
              conference_room: `/admin-panel/booking/conference-room-bookings/create?conference_room=${this.selectedId}`,
              bookable: `/admin-panel/booking/bookable-bookings/create?activeTab=${activeTab}&bookable=${this.selectedId}`
            };
            window.location.href = routes[this.selectedItemType];
          }else{
            if(this.hybrid) {
              this.$emit('selected', this.selected, this.selectedItemType);
            }
          }
      },

      editItem() {
        if(this.whichDashboard === "new") {
        const routes = {
          desk: `/admin-panel/resource/desks/${this.selectedId}/edit`,
          conference_room: `/admin-panel/resource/conference-rooms/${this.selectedId}/edit`,
          bookable: `/admin-panel/resource/bookables/${this.selectedId}/edit`,
        };
        window.location.href = routes[this.selectedItemType];
        }
      }

    }
}
</script>

<style scoped>
#map {
    background: white;
}
.leaflet-tooltip{
    padding: 0 !important;
    margin: 0 !important;
}
.checkedIn{
    background-color: #3fff33 !important;
    border: 1px solid #3fff33 !important;
}
.leaflet-control-container{
    display: none;
}
.avatar-div{
    display:inline-flex;
    align-items:center;
    padding:0;
    margin:0;
    width: 20px;
    height: 20px;
    font-size: 12px;
    text-align: center
}
</style>
